import axios from "axios";
import { isSupportLocalStorage, bake_cookie, read_cookie, delete_cookie } from "./cookieHandler";

export function setAuthenticationToken(result) {
    window.localStorage.setItem("auth_data", JSON.stringify(result));
}

export function getAuthenticationToken() {
    return JSON.parse(window.localStorage.getItem("auth_data"));
}

export function deleteAuthenticationToken() {
    if (isSupportLocalStorage()) {
        window.localStorage.removeItem("auth_data");
    } else {
        delete_cookie("auth_data");
    }
}

export function IsAuthenticated() {
        return window.localStorage.getItem("auth_data") !== null;
}

export const setAuth = (access_token) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
}

